import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BbTableService } from '../../../services/bb-table.service';
import { Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';

@Component({
	selector: 'bb-table-local-filter',
	templateUrl: './bb-table-local-filter.component.html',
	styleUrls: ['./bb-table-local-filter.component.scss']
})

export class BbTableLocalFilterComponent implements OnInit, OnDestroy {
	totalChangedObserver: Subscription;
	total: number = (this.bbTableService.totalAmount ? this.bbTableService.totalAmount : 0);

	filter = new UntypedFormControl();

	constructor(private bbTableService: BbTableService) { }

	ngOnInit() {
		this.filter.valueChanges
			.pipe(
				debounceTime(400),
				distinctUntilChanged()
			)
			.subscribe(newValue => {
				this.bbTableService.setLocalFilter(newValue);
			});

		this.totalChangedObserver = this.bbTableService.totalChangedObservable.subscribe((total: number) => this.total = total);
	}

	ngOnDestroy() {
		this.totalChangedObserver.unsubscribe();
	}
}
